import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';
import { apiClient } from 'shared/api/';
import { useUser } from 'shared/api/tanstack';
import { ButtonCustom } from 'shared/ui/button-custom';
import styles from './latest-applications.module.scss';

export const LatestApplications = () => {
  const navigate = useNavigate();

  const { data: user } = useUser();

  function GoToApp(type: string, appId: string) {
    if (type === 'select') {
      const app: any = lastSelectApp.find((app: any) => app.documentId === appId);
      if (!app) return;
      if (user?.user_type === 'supplier' || user?.user_type === 'leasing') {
        const offer = app?.select_offers.find((offer: any) => offer.name === user.username);
        if (!offer) return;
        navigate(`/app/select/${app.custom_uid}/${offer.custom_uid}`);
      } else {
        navigate(`/dashboard/app/select/${app.id}`);
      }
    } else if (type === 'leasing') {
      const app: any = lastLeasingApp.find((app: any) => app.documentId === appId);
      if (!app) return;
      if (user?.user_type === 'leasing') {
        const offer = app?.leasing_offers.find((offer: any) => offer.name === user.username);
        if (!offer) return;
        navigate(`/app/leasing/${app.custom_uid}/${offer.custom_uid}`);
      } else {
        navigate(`/dashboard/app/leasing/${app.id}`);
      }
    }
  }

  const getLastSelectApp = async () => {
    try {
      const response = await apiClient.get('/select-applications/last');
      const data = response?.data?.data
        ? response.data.data.filter((item: any) => item.fulfilled !== false)
        : [];
      setSelectLastApp(data);
    } catch (error) {
      console.error('Ошибка при получении данных: ', error);
    }
  };

  const getLastLeasingApp = async () => {
    try {
      if (user?.user_type !== 'supplier') {
        const response = await apiClient.get('/leasing-applications/last');
        const data = response?.data?.data
          ? response.data.data.filter((item: any) => item.fulfilled !== false)
          : [];
        setLeasingLastApp(data);
      }
    } catch (error) {
      console.error('Ошибка при получении данных: ', error);
    }
  };
  const isNew = (status: string) => {
    return status == 'Новая';
  };
  const isProcessing = (status: string) => {
    return status == 'В обработке';
  };
  const isProcessed = (status: string) => {
    return status == 'Обработана';
  };
  const isConfirmation = (status: string) => {
    return status == 'Ожидает подтвержд.';
  };
  const isConfirmed = (status: string) => {
    return status == 'На оформлении';
  };
  const isCompleted = (status: string) => {
    return status == 'Выполнена';
  };
  const isClosed = (status: string) => {
    return status == 'Закрыта';
  };
  const isCanceled = (status: string) => {
    return status == 'Отменена';
  };

  const getStatusApp = (status: string) => {
    if (status == 'Ожидает подтвержд.') {
      return 'На одобрении';
    }
    return status;
  };
  const [lastSelectApp, setSelectLastApp] = useState([]);
  const [lastLeasingApp, setLeasingLastApp] = useState([]);
  const [leasingEmpty, setLeasingEmpty] = useState(true);

  useEffect(() => {
    getLastSelectApp();
    getLastLeasingApp();
  }, []);

  useEffect(() => {
    setLeasingEmpty(lastLeasingApp.length < 3);
  }, [lastLeasingApp]);

  return (
    <Box className={styles.latestApp}>
      {(
        <Box className={styles.latestCardWrapper}>
          <Box className={styles.latestCardHeader}>
            <span className={styles.latestHeaderTitle}>Подбор ТС</span>
            {
              <Link className={styles.latestHeaderLink} to={'/dashboard/all/select'}>
                Смотреть все
              </Link>
            }

            {['agent', 'client'].includes(user?.user_type) && (
              <div className={styles.btnMob}>
                <ButtonCustom
                  className={styles.btnMob}
                  onClick={() => navigate('/dashboard/new/select')}
                >
                  Создать новую заявку
                </ButtonCustom>
              </div>
            )}
          </Box>
          <Box className={styles.latestCardBlock}>
            {lastSelectApp.map((app: any) => (
              <Box key={app.documentId} className={styles.latestCard}>
                <span className={styles.latestCardTitle}>{`Заявка № ${app.id}`}</span>
                <Box className={styles.latestCardDesc}>
                  <Box className={styles.latestCardDescRow}>
                    <span className={styles.cardDescTitle}>Транспортное средство</span>
                    <span className={styles.cardDescValue}>
                      {app.car_type}/{app.car_subtype}
                    </span>
                  </Box>
                  <Box className={styles.latestCardDescRow}>
                    <span className={styles.cardDescTitle}>Марка</span>
                    <span className={styles.cardDescValue}>{app.car_brand}</span>
                  </Box>
                  <Box className={styles.latestCardDescRow}>
                    <span className={styles.cardDescTitle}>Модель</span>
                    <span className={styles.cardDescValue}>{app.vehicle}</span>
                  </Box>
                  <Box className={styles.latestCardDescRow}>
                    <span className={styles.cardDescTitle}>Бюджет на покупку</span>
                    <span className={styles.cardDescValue}>
                      {new Intl.NumberFormat('ru-RU').format(app?.budget as number)} ₽
                    </span>
                  </Box>
                  <Box className={styles.latestCardDescRow}>
                    <span className={styles.cardDescTitle}>Статус заявки</span>
                    <span
                      className={clsx([
                        `${styles.cardDescValue}`,
                        `${styles.cardDescValueStatus}`,
                        isNew(app.status_app) && `${styles.statusNew}`,
                        isProcessing(app.status_app) && `${styles.statusProcessing}`,
                        isProcessed(app.status_app) && `${styles.statusProcessed}`,
                        isConfirmation(app.status_app) && `${styles.statusConfirmation}`,
                        isConfirmed(app.status_app) && `${styles.statusConfirmed}`,
                        isCompleted(app.status_app) && `${styles.statusCompleted}`,
                        isClosed(app.status_app) && `${styles.statusClosed}`,
                        isCanceled(app.status_app) && `${styles.statusCanceled}`,
                      ])}
                    >
                      {getStatusApp(app.status_app)}
                    </span>
                  </Box>
                </Box>
                <ButtonCustom
                  className={styles.btn}
                  onClick={() => GoToApp('select', app.documentId)}
                >
                  Перейти к заявке
                </ButtonCustom>
              </Box>
            ))}

            {['agent', 'client'].includes(user?.user_type) && (
              <Box className={styles.newCard}>
                <ButtonCustom
                  className={styles.btn}
                  onClick={() => navigate('/dashboard/new/select')}
                >
                  Создать новую заявку
                </ButtonCustom>
              </Box>
            )}
          </Box>
          {
            <Link className={styles.latestHeaderLinkMob} to={'/dashboard/all/select'}>
              Смотреть все
            </Link>
          }
        </Box>
      )}
      {user?.user_type !== 'supplier' && (
        <Box className={styles.latestCardWrapper}>
          <Box className={styles.latestCardHeader}>
            <span className={styles.latestHeaderTitle}>Лизинг</span>
            {!leasingEmpty && (
              <Link className={styles.latestHeaderLink} to={'/dashboard/all/leasing'}>
                Смотреть все
              </Link>
            )}
            {['agent', 'client'].includes(user?.user_type) && (
              <ButtonCustom
                className={styles.btnMob}
                onClick={() => navigate('/dashboard/new/leasing')}
              >
                Создать новую заявку
              </ButtonCustom>
            )}
          </Box>
          <Box className={styles.latestCardBlock}>
            {lastLeasingApp.map((app: any) => (
              <Box key={app.documentId} className={styles.latestCard}>
                <span className={styles.latestCardTitle}>Заявка № {app.id}</span>
                <Box className={styles.latestCardDesc}>
                  <Box className={styles.latestCardDescRow}>
                    <span className={styles.cardDescTitle}>Транспортное средство</span>
                    <span className={styles.cardDescValue}>
                      {app.car_type}/{app.car_subtype}
                    </span>
                  </Box>
                  <Box className={styles.latestCardDescRow}>
                    <span className={styles.cardDescTitle}>Марка</span>
                    <span className={styles.cardDescValue}>{app.car_brand}</span>
                  </Box>
                  <Box className={styles.latestCardDescRow}>
                    <span className={styles.cardDescTitle}>Модель</span>
                    <span className={styles.cardDescValue}>{app.vehicle}</span>
                  </Box>
                  <Box className={styles.latestCardDescRow}>
                    <span className={styles.cardDescTitle}>Стоимость предмета лизинга</span>
                    <span className={styles.cardDescValue}>
                      {new Intl.NumberFormat('ru-RU').format(app?.price as number)} ₽
                    </span>
                  </Box>
                  <Box className={styles.latestCardDescRow}>
                    <span className={styles.cardDescTitle}>Статус заявки</span>
                    <span
                      className={clsx([
                        `${styles.cardDescValue}`,
                        `${styles.cardDescValueStatus}`,
                        isNew(app.status_app) && `${styles.statusNew}`,
                        isProcessing(app.status_app) && `${styles.statusProcessing}`,
                        isProcessed(app.status_app) && `${styles.statusProcessed}`,
                        isConfirmation(app.status_app) && `${styles.statusConfirmation}`,
                        isConfirmed(app.status_app) && `${styles.statusConfirmed}`,
                        isCompleted(app.status_app) && `${styles.statusCompleted}`,
                        isClosed(app.status_app) && `${styles.statusClosed}`,
                        isCanceled(app.status_app) && `${styles.statusCanceled}`,
                      ])}
                    >
                      {getStatusApp(app.status_app)}
                    </span>
                  </Box>
                </Box>
                <ButtonCustom
                  className={styles.btn}
                  onClick={() => GoToApp('leasing', app.documentId)}
                >
                  Перейти к заявке
                </ButtonCustom>
              </Box>
            ))}
            {['agent', 'client'].includes(user?.user_type) && (
              <Box className={styles.newCard}>
                <ButtonCustom
                  className={styles.btn}
                  onClick={() => navigate('/dashboard/new/leasing')}
                >
                  Создать новую заявку
                </ButtonCustom>
              </Box>
            )}
          </Box>
          {!leasingEmpty && (
            <Link className={styles.latestHeaderLinkMob} to={'/dashboard/all/leasing'}>
              Смотреть все
            </Link>
          )}
        </Box>
      )}
    </Box>
  );
};
